import { render, staticRenderFns } from "./OrganizationChartForm.vue?vue&type=template&id=745c367d&"
import script from "./OrganizationChartForm.vue?vue&type=script&lang=js&"
export * from "./OrganizationChartForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports